import { render, staticRenderFns } from "./DependentInformation.vue?vue&type=template&id=4cf3a688&scoped=true"
import script from "./DependentInformation.vue?vue&type=script&lang=js"
export * from "./DependentInformation.vue?vue&type=script&lang=js"
import style0 from "./DependentInformation.vue?vue&type=style&index=0&id=4cf3a688&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf3a688",
  null
  
)

export default component.exports